type TProps = {
  code?: string;
  message?: string;
};

const GENERIC_RETRY_PAYMENT_ERROR = 'Something went wrong. Please try again later';

const RETRY_PAYMENT_ERROR_MESSAGES: Record<string, string> = {
  'No payment methods found': 'Add a payment method, then retry.',
  'Subscription can no longer be retried':
    'This subscription can no longer be retried. Please contact support@voicescript.ai.',
  ORGANIZATION_EXTERNALLY_MANAGED: "This organization's subscriptions are managed externally.",
};

export const mapRetryPaymentError = ({ code, message }: TProps): string => {
  const mappedByCode = code ? RETRY_PAYMENT_ERROR_MESSAGES[code] : undefined;
  if (mappedByCode) {
    return mappedByCode;
  }

  const text = message?.trim() || code;

  return text ? RETRY_PAYMENT_ERROR_MESSAGES[text] ?? text : GENERIC_RETRY_PAYMENT_ERROR;
};
